import DeviceReport1Page from './device-report-1-page';

export default DeviceReport1Page;